import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Kendo
import { DropDownsModule} from '@progress/kendo-angular-dropdowns';



@NgModule({
  declarations: [],
  imports: [
    DropDownsModule,
    CommonModule,
  ],
  exports: [
    DropDownsModule,
  ]
})
export class KendoDropdownlistModule { }
